import axios from "axios";
import { SearchStudio } from "../_constants/api.constant";
import { getSelfToken } from "../../_helpers/auth/secureToken";
export async function associateStudioSearch(postData,actiontype){
    switch(actiontype)
    {
    case 'SEARCH':
        {
            const response = await axios.get(
                SearchStudio.SEARCH,
                {   params:{search:postData.searchValue,
                },
                    headers: {
                        Authorization: 'Token ' + getSelfToken(),
                    }, 
                }
            ).then(function (response) {
                return response;
            }).catch(function (error) {
                // handle error
                console.log(error);
                console.log(error.response);
                return error.response;
            });
            return response;
        }    
    default:{return}
    }
}